import * as posthog from "@lib/posthog";
import type { User } from "@/api/types";

export function init() {
  try {
    posthog.init();
  } catch (err) {
    console.error("[analytics] init:", err);
  }
}

export function track(eventName: string, props?: Record<string, any>) {
  try {
    posthog.client.capture(eventName, props);
  } catch (err) {
    console.error("[analytics] track:", err);
  }
}

export function captureException(error: unknown, props?: Record<string, any>) {
  try {
    posthog.client.captureException(error, props);
  } catch (err) {
    console.error("[analytics] captureException:", err);
  }
}

export function identify(user: User) {
  try {
    posthog.identify(user);
  } catch (err) {
    console.error("[analytics] identify:", err);
  }
}

/** Ties the active gym to feature flag evaluation; call on resolve and every switch. */
export function setGymForFlags(gym: { id: string; org: string } | null) {
  try {
    posthog.setGymForFlags(gym);
  } catch (err) {
    console.error("[analytics] setGymForFlags:", err);
  }
}

export function reset() {
  try {
    posthog.reset();
  } catch (err) {
    console.error("[analytics] reset:", err);
  }
}
